import { MetaInfo } from "@/components/meta-info"
import { SettingsHeader } from "../settings-header"
import { RoutinesSection } from "./routines-section"

export function RoutinesPage() {
	return (
		<>
			<MetaInfo title="Routines Settings" />

			<SettingsHeader
				title="Routines"
				subtitle="Triage every thread the moment a message arrives."
			/>

			<RoutinesSection />
		</>
	)
}
